/**
 * 专利卫士 精准服务名单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>精准服务名单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.code" style="width:160px" placeholder="输入机构code" clearable></el-input>
        <el-input size="small" v-model="formInline.name" style="width:160px" placeholder="输入机构名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="所属省份">
        <el-select size="small" v-model="formInline.province" style="width:100px" placeholder="请选择" filterable clearable>
          <el-option v-for="type in provinceData" :label="type" :value="type" :key="type"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="批次">
        <el-select size="small" v-model="formInline.batch" style="width:100px" placeholder="请选择" clearable>
          <el-option v-for="type in batchData" :label="type" :value="type" :key="type"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="80">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="80">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="name" align="center" label="名称" min-width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="code" align="center" label="代码" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="province" align="center" label="省份" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="agent_num" align="center" label="代理人数量" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="batch" align="center" label="入选批次" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="years" align="center" label="成立年限" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="legal_person" align="center" label="法人" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="level" align="center" label="等级" width="60" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="tel" align="center" label="联系电话" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="address" align="center" label="联系地址" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="email" align="center" label="邮箱" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="160">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="primary" @click="handleAgent(scope.$index, scope.row)">代理人</el-button>
          <el-button size="mini" type="danger" @click="deleteAgency(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm" :rules="infoFormRules">
        <el-form-item label="机构名称" prop="name">
          <el-input size="small" v-model="infoForm.name" placeholder="请输入机构名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="机构代码" prop="code">
          <el-input size="small" v-model="infoForm.code" placeholder="请输入机构代码" clearable></el-input>
        </el-form-item>
        <el-form-item label="所属省份" prop="province">
          <el-select size="small" v-model="infoForm.province" style="width:100px" placeholder="请选择" filterable clearable>
            <el-option v-for="type in provinceData" :label="type" :value="type" :key="type"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入选批次" prop="batch">
          <el-select size="small" v-model="infoForm.batch" style="width:100px" placeholder="请选择" clearable>
            <el-option v-for="type in batchData" :label="type" :value="type" :key="type"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="成立年限" prop="years">
          <el-input size="small" v-model="infoForm.years" placeholder="请输入成立年限" clearable></el-input>
        </el-form-item>
        <el-form-item label="机构法人" prop="legal_person">
          <el-input size="small" v-model="infoForm.legal_person" placeholder="请输入机构法人" clearable></el-input>
        </el-form-item>
        <el-form-item label="信用等级" prop="level">
          <el-input size="small" v-model="infoForm.level" placeholder="请输入信用等级" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="tel">
          <el-input size="small" v-model="infoForm.tel" placeholder="请输入机构法人" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系地址" prop="address">
          <el-input size="small" v-model="infoForm.address" placeholder="请输入联系地址" clearable></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input size="small" v-model="infoForm.email" placeholder="请输入邮箱地址" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveAgency('infoForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 代理人列表 -->
    <el-dialog :title="title" :visible.sync="agentListFormVisible" width="50%" @click="closeAgentDialog()">
      <div style="height: 600px; overflow: auto;">
        <el-table size="small" :data="agentData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark">
        <el-table-column align="center" type="selection" width="80">
        </el-table-column>
        <el-table-column align="center" type="index" label="序号" width="80">
        </el-table-column>
        <el-table-column prop="id" v-if="idShow">
        </el-table-column>
        <el-table-column prop="name" align="center" label="姓名" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="cert_number" align="center" label="执业证号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="years" align="center" label="执业年限" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="major" align="center" label="领域" show-overflow-tooltip>
        </el-table-column>
        <!-- <el-table-column align="center" label="操作" min-width="160">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteAgent(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    </el-dialog>
  </div>
</template>

<script>
import { 
  getAgencyBatch,
  getAgencyProvince,
  getAgencyList,
  editAgency,
  delAgency,
  getAgencyAgentList,
  delAgencyAgent
} from '../../api/wechatMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      agentListFormVisible: false,//控制代理人列表弹窗
      title: '',
      multipleSelection: [],
      infoForm: {
        id: '',
        name: '',
        code: '',
        province: '',
        batch: '',
        years: '',
        legal_person: '',
        level: '',
        tel: '',
        address: '',
        email: ''
      },
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      formInline: {
        page: 1,
        ps: 10,
        code: '',
        name: '',
        province: '',
        batch: ''
      },
      agentForm: {
        search: '',
        code: ''
      },
      batchData: [],
      provinceData: [],
      listData: [], //用户数据
      agentData: [], //代理人数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
         // 表单验证
      infoFormRules: {
        name: [
          { required: true, message: '请输入机构名称', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入机构代码', trigger: 'blur' }
        ],
        province: [
          { required: true, message: '请选择所属省份', trigger: 'blur' }
        ],
        batch: [
          { required: true, message: '请选择所属批次', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入联系地址', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        years: [
          { required: true, message: '请输入成立年限', trigger: 'blur' }
        ],
        legal_person: [
          { required: true, message: '请输入机构法人', trigger: 'blur' }
        ],
        level: [
          { required: true, message: '请输入信用等级', trigger: 'blur' }
        ]
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    this.getBatchData()
    this.getProvinceData()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 获取公司列表
    getdata(parameter) {
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
       getAgencyList(parameter)
        .then(res => {
          this.loading = false
          res = checkLogin(res);
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 查询批次数据
    getBatchData() {
      getAgencyBatch({})
      .then(res=>{
        if(res.code == 200){
          this.batchData = res.data
        }
      })
    },
    // 查询省份数据
    getProvinceData(){
      getAgencyProvince({})
      .then(res=>{
        if(res.code == 200){
          this.provinceData = res.data
        }
      })
    },
    // 显示编辑页面
    handleEdit: function(index,row){
      if(row){
        this.infoForm.id = row.id
        this.infoForm.name = row.name
        this.infoForm.code = row.code
        this.infoForm.province = row.province
        this.infoForm.batch = row.batch
        this.infoForm.years = row.years
        this.infoForm.legal_person = row.legal_person
        this.infoForm.level = row.level
        this.infoForm.tel = row.tel
        this.infoForm.address = row.address
        this.infoForm.email = row.email
        this.title = '编辑机构信息'
      }else{
        this.title = '添加机构信息'
        this.infoForm.id = ''
        this.infoForm.name = ''
        this.infoForm.code = ''
        this.infoForm.province = ''
        this.infoForm.batch = ''
        this.infoForm.years = ''
        this.infoForm.legal_person = ''
        this.infoForm.level = ''
        this.infoForm.tel = ''
        this.infoForm.address = ''
        this.infoForm.email = ''
      }
      this.editFormVisible = true
    },
    // 显示代理人列表
    handleAgent(index,row){
      let param = {
        code: row.code,
        search: this.agentForm.search
      }
      getAgencyAgentList(param)
      .then(res=>{
        if(res.code == 200){
          this.agentData = res.data
          this.title = '代理人列表'
          this.agentListFormVisible = true
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    //显示详情界面
    handleInfo: function(index, row) {
      console.log(row)
      this.editFormVisible = true
      this.infoForm = row
    },
    // 保存代理机构信息
    saveAgency(infoForm){
        //校验参数
      this.$refs[infoForm].validate(valid => {
        if(valid){
           editAgency(this.infoForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              res = checkLogin(res)
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
        }else{
          return false;
        }
      })
    },
    // 删除代理机构
    deleteAgency(index, row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        delAgency({id: row.id})
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getdata()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(() => {
          this.loading = false
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },
    closeAgentDialog(){
      this.agentListFormVisible = false
    },
    closeEditDoc(){
      this.editDocFormVisible = false
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #868484b5;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 180px;
  height: 96px;
  display: block;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/wechat/agencyList.vue